import AbstractPopup from "./AbstractPopup";
import Button from "../../views/components/Button";
import ViewManager from "../../utils/ViewManager";
import { DefaultLayers } from "../../utils/Layers";
import PointerEvents from "../../const/PointerEvents";
import TextField from "../../views/components/TextField";
import Locale from "../../utils/Locale";
import errorModel from "../../model/ErrorModel";
import SoundController from '../../utils/SoundController';
import SoundVars from '../../const/SoundVars';

export default class ErrorPopup extends AbstractPopup {
    public title: TextField;
    public text: TextField;
    public closeBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function) {
        super.show();
        this.scene = this.layer.setScene("error");
        this.scene.interactive = true;
        this.closeBtn = this.scene.buttons.get("close");
        this.text = this.scene.sceneTextFields.get("text") as TextField;
        this.text.text = Locale.getString("error." + errorModel.errorCode)
        this.title = this.scene.sceneTextFields.get("title") as TextField;
        this.title.text = Locale.getString("gui_lbl_error");

        this.closeBtn.once(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            if (callback) {
                callback();
            }

            this.hide();
        });
    }

    public setText(value: string) {
        this.text.text = value;
    }

    public setTitle(value: string) {
        this.title.text = value;
    }

    protected hideFromKeyboard() {}
}
